export default {
  beforeMount(el, { value }) {
    el._clickHandler = (e) => {
      if (!(el === e.target || el.contains(e.target))) value(e)
    }
    document.addEventListener('click', el._clickHandler, { capture: true })
  },

  unmounted(el) {
    document.removeEventListener('click', el._clickHandler, { capture: true })
  },
}
